"use strict";
/**
 * Accuracy calculation utilities for LingoShade
 * Centralized accuracy calculations for dictations and text comparisons
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDictationAccuracy = calculateDictationAccuracy;
exports.calculateTextAccuracy = calculateTextAccuracy;
exports.calculateAccuracyDetailed = calculateAccuracyDetailed;
exports.calculateCharacterAccuracy = calculateCharacterAccuracy;
/**
 * Calculate dictation accuracy based on expected and actual sentences
 * Used for dictation results across web and mobile platforms
 */
function calculateDictationAccuracy(expectedSentences, actualSentences) {
    let totalWords = 0;
    let correctWords = 0;
    expectedSentences.forEach((sentence, index) => {
        const userInput = actualSentences[index] || "";
        // Skip sentences marked as skipped
        if (userInput === "[SKIPPED]")
            return;
        const expectedWords = sentence
            .toLowerCase()
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0);
        const actualWords = userInput
            .toLowerCase()
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0);
        totalWords += expectedWords.length;
        expectedWords.forEach((word, i) => {
            if (actualWords[i] === word) {
                correctWords++;
            }
        });
    });
    return totalWords > 0 ? Math.round((correctWords / totalWords) * 100) : 0;
}
/**
 * Calculate simple text accuracy (word-by-word comparison)
 * Used for basic text comparison scenarios
 */
function calculateTextAccuracy(expectedText, actualText) {
    const expectedWords = expectedText
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0);
    const actualWords = actualText
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0);
    const totalWords = expectedWords.length;
    if (totalWords === 0)
        return 100;
    let correctWords = 0;
    expectedWords.forEach((word, i) => {
        if (actualWords[i] === word) {
            correctWords++;
        }
    });
    return Math.round((correctWords / totalWords) * 100);
}
/**
 * Calculate accuracy with detailed breakdown
 * Returns both percentage and word counts
 */
function calculateAccuracyDetailed(expectedSentences, actualSentences) {
    let totalWords = 0;
    let correctWords = 0;
    let skippedSentences = 0;
    expectedSentences.forEach((sentence, index) => {
        const userInput = actualSentences[index] || "";
        if (userInput === "[SKIPPED]") {
            skippedSentences++;
            return;
        }
        const expectedWords = sentence
            .toLowerCase()
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0);
        const actualWords = userInput
            .toLowerCase()
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0);
        totalWords += expectedWords.length;
        expectedWords.forEach((word, i) => {
            if (actualWords[i] === word) {
                correctWords++;
            }
        });
    });
    const accuracy = totalWords > 0 ? Math.round((correctWords / totalWords) * 100) : 0;
    const incorrectWords = totalWords - correctWords;
    return {
        accuracy,
        totalWords,
        correctWords,
        incorrectWords,
        skippedSentences,
    };
}
/**
 * Calculate accuracy for character-level comparison
 * Useful for more precise dictation analysis
 */
function calculateCharacterAccuracy(expectedText, actualText) {
    const expectedChars = expectedText.toLowerCase().replace(/\s+/g, "");
    const actualChars = actualText.toLowerCase().replace(/\s+/g, "");
    const totalChars = expectedChars.length;
    if (totalChars === 0)
        return 100;
    let correctChars = 0;
    const minLength = Math.min(expectedChars.length, actualChars.length);
    for (let i = 0; i < minLength; i++) {
        if (expectedChars[i] === actualChars[i]) {
            correctChars++;
        }
    }
    return Math.round((correctChars / totalChars) * 100);
}
//# sourceMappingURL=accuracyCalculation.js.map